import { CalculateMarginProps } from '@/types'
import styles from './margin-metrics.module.css'
import { checkCm3Margin, checkGrossMargin } from '@/helpers'

export const variants: Record<string, string> = {
  danger: styles['icon--danger'],
  success: styles['icon--success'],
  warning: styles['icon--warning'],
}

export const textVariants: Record<string, string> = {
  danger: styles.danger,
  success: styles.success,
  warning: styles.warning,
}

export const generateGrossMarginClasses = (grossMargin: number) => {
  const gross = checkGrossMargin(grossMargin)

  return textVariants?.[gross] || ``
}

export const generateCm3MarginClasses = (cm3Margin: number) => {
  const cm3 = checkCm3Margin(cm3Margin)

  return textVariants?.[cm3] || ``
}

export const generateIconClasses = (data: CalculateMarginProps) => {
  const gross = checkGrossMargin(data?.grossMargin)
  const cm3 = checkCm3Margin(data?.cm3Margin)

  if (gross === 'danger' || cm3 === 'danger')
    return `${styles.icon} ${variants.danger}`

  if (gross === 'warning' || cm3 === 'warning')
    return `${styles.icon} ${variants.warning}`

  if (gross === 'success' || cm3 === 'success')
    return `${styles.icon} ${variants.success}`

  return `${styles.icon} `
}
